import { createContext, useContext, useEffect } from 'react';

export interface PageLayoutContextValue {
  setWide: (wide: boolean) => void;
}

export const PageLayoutContext = createContext<PageLayoutContextValue>({
  setWide: () => {},
});

export const usePageWide = (wide: boolean = true): void => {
  const { setWide } = useContext(PageLayoutContext);
  useEffect(() => {
    setWide(wide);
    return () => setWide(false);
  }, [wide, setWide]);
};
